export const optionsChartBarVendas = {
  title: {
    display: true,
    padding: 20,
    text: "Vendas por Fornecedor",
  },
  legend: {
    position: "bottom",
  },
  layout: {
    padding: {
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
    },
  },
  scales: {
    yAxes: [
      {
        ticks: {
          beginAtZero: true,
        },
      },
    ],
    xAxes: [
      {
        ticks: {
          padding: 25,
        },
      },
    ],
  },
  plugins: {
    datalabels: {
      labels: {
        title: {
          font: {
            weight: "bold",
          },
        },
      },
    },
  },
};

export const options = {
  maintainAspectRatio: false,
  title: {
    display: true,
    padding: 20,
    text: "Vendas por Fornecedor",
    align: "start",
  },
  legend: {
    position: "bottom",
    align: "start",
  },
  responsive: false,
  tooltips: {
    mode: "label",
  },
  elements: {
    line: {
      fill: false,
    },
  },
  scales: {
    xAxes: [
      {
        display: true,
        gridLines: {
          display: false,
        },
        ticks: {
          autoSkip: false,
          maxRotation: 45,
          minRotation: 45,
          padding: 25,
        },
      },
    ],
    yAxes: [
      {
        type: "linear",
        display: true,
        position: "left",
        id: "y-axis-1",
        gridLines: {
          display: true,
        },
        labels: {
          show: false,
        },
        ticks: {
          beginAtZero: true,
        },
      },
    ],
  },
  plugins: {
    datalabels: {
      labels: {
        title: {
          font: {
            weight: "bold",
          },
        },
      },
    },
  },
};
